import client from './index'

const myadvisor = (semester) => client['api'].get(`myadvisor`, {params: semester})
// Akademik 
const getDataByLectureAcademic = (data,lecture_id) => client['api'].get(`academic-advisor/students/${lecture_id}`, {params: data})
const getData = (data,url) => client['api'].get(`${url}/students`, {params: data})

const multistoreAcademic = (data) => client['api'].post(`academic-advisor/multistore`, data)
const destroyAcademic = (id, lecture_id) => client['api'].delete(`academic-advisor/deleteByLecture/${id}`, {params: {lecture_id : lecture_id}})
// Common
const getUnlistStudent = (url) => client['api'].get(`unlistStudent/${url}`)
const ListOfLecture = (url) => client['api'].get(`/unlistLecture/${url}`)
const store = (data, url) => client['api'].post(`${url}`, data)
const update = (data,id, url) => client['api'].patch(`${url}/${id}`, data)
const destroy = (id, url) => client['api'].delete(`${url}/${id}`)

// dynamic
const getStudentsAdvisor = (data, url) => client['api'].get(`${url}/alldata`, {params: data})
const uploadExcel = (data, url) => client['api'].post(`${url}/excel`, data, {"Content-Type": "multipart/form-data"})

export {
    myadvisor,
    getDataByLectureAcademic,
    store,
    update,
    destroy,
    destroyAcademic,
    getUnlistStudent,
    multistoreAcademic,
    ListOfLecture,
    getData,
    uploadExcel,
    getStudentsAdvisor
}